const Skeleton = () => {
  return (
    <div className="grid w-full animate-pulse grid-cols-3 gap-6">
      <div className="h-60 w-full rounded bg-gray-200" />
      <div className="h-60 w-full rounded bg-gray-200" />
      <div className="h-60 w-full rounded bg-gray-200" />
    </div>
  );
};

export default Skeleton;
